














import Vue from 'vue';
import Cookie from 'js-cookie';
import * as log from 'loglevel';

import Component from 'vue-class-component';
import Screencast from './Screencast.vue';

import { SlidesIds } from '@/config/globalVariables';
import { Translate } from '@/lang/Translator';

log.setLevel(0);

@Component({
  components: { Screencast },
})
export default class Concierge extends Vue {
  // data
  private currentId = SlidesIds.startScreen;

  // computed
  get t(): Translate {
    return this.$store.state.t;
  }

  get isHidePlaceholder() {
    const hidePlaceholderSlides = [
      SlidesIds.redirect_to_support,
      SlidesIds.requestToContact,
      SlidesIds.you_were_redirected,
    ];

    return hidePlaceholderSlides.includes(this.currentId);
  }
  get placeholderText() {
    if (this.currentId === SlidesIds.TYPContactForm) {
      return this.t.text('all-operators-is-offline');
    }
    return this.t.text('select-action');
  }

  // methods
  private isVisibleApplication(): boolean {
    const currentPage = window.location.pathname;
    const getData = Cookie.getJSON('fromAssistant');
    let pageIndex = -1;

    if (getData) {
      pageIndex = getData.findIndex((item: { url: string, page: number }) => `/${item.url}` === currentPage);
    }

    return currentPage === '/' || pageIndex !== -1;
  }

  private created() {
    this.$emit('is-show-application', this.isVisibleApplication());
  }
}
